import { useContext, useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import { ProfileContext } from '../../contexts';
import { exportMentee, exportMentor } from './helpers';

export const AdminButtons = () => {
  const { profile } = useContext(ProfileContext);
  const [loading, setLoading] = useState(false);

  if (!profile?.isAdmin) return null;

  const handleExport = async (func) => {
    if (loading) return;

    setLoading(true);
    await func();
    setLoading(false);
  };

  const spinner = <CircularProgress color="secondary" size={24} />;

  return (
    <>
      <Button
        disabled={loading}
        onClick={() => handleExport(exportMentor)}
        variant="contained"
      >
        {loading ? spinner : 'Export Mentor Report'}
      </Button>
      <Button
        disabled={loading}
        onClick={() => handleExport(exportMentee)}
        variant="contained"
      >
        {loading ? spinner : 'Export Mentee Report'}
      </Button>
    </>
  );
};
